import {
  defaultLocale,
  defaultPropertyId,
  localeOptions,
  propertyOptions,
  defaultDomains,
} from '../../constants/defaultValues';

import {
  CHANGE_LOCALE,
  CHANGE_PROPERTY,
  CHANGE_DOMAINS,
  CHANGE_TIMEZONE,
  CHANGE_CURRENCY,
  CHANGE_USER,
  CHANGE_USER_NAME,
  CHANGE_GROUP,
  CHECK_VOUCHER_ENGINE,
  CHANGE_PROPERTY_TAGS,
  CHECK_SALESFORCE,
  CHANGE_CLODBEDS,
  CHANGE_GROUP_LOGO,
  CHANGE_TABS,
  CHANGE_INSTAGRAM,
  CHANGE_GROUP_BILLING_CURRENCY,
  CHANGE_SERVICE_PROVIDER,
  CHANGE_PROPERTY_PROVIDER,
  CHANGE_CURRENT_INTEGRATION_TAB
} from '../actions';

const INIT_STATE = {
  locale:
    localStorage.getItem('currentLanguage') &&
      localeOptions.filter(
        (x) => x.id === localStorage.getItem('currentLanguage')
      ).length > 0
      ? localStorage.getItem('currentLanguage')
      : defaultLocale,
  // propertyId: localStorage.getItem('currentPropertyId') || '',
  propertyId: localStorage.getItem('currentPropertyId') !== null &&
    localStorage.getItem('currentPropertyId') !== undefined
    ? localStorage.getItem('currentPropertyId')
    : '',
  domains: localStorage.getItem('currentDomains') || defaultDomains,
  timeZone: localStorage.getItem('timeZone') || 'Pacific/Auckland',
  currency: localStorage.getItem('currency') || 'NZD',
  email: localStorage.getItem('email') || '',
  propertyTags: localStorage.getItem('propertyTags') || [],
  userName: localStorage.getItem('userName') || '',
  isVoucherEngine: localStorage.getItem('isVoucherEngine') || false,
  groupId: localStorage.getItem('groupId') || '',
  salesforceId: localStorage.getItem('salesforceId') || '',
  cloudBedsId: localStorage.getItem('cloudbedsId') || '',
  instagramId: localStorage.getItem('instagramId') || '',
  serviceProviderLogo: localStorage.getItem('service_provider_logo') || '',
  integrationTab: localStorage.getItem('integrationTab') || 'channels',
  groupBillingCurrency: localStorage.getItem('group_billing_currency') || 'NZD',
  serviceProvider: localStorage.getItem('service_provider') || '1',
  currentIntegrationTab: localStorage.getItem('currentIntegrationTab') || '',
  providerPropertyId :'',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
     case CHANGE_PROPERTY_PROVIDER:
      return { ...state, providerPropertyId: action.payload };
    case CHANGE_LOCALE:
      return { ...state, locale: action.payload };
    case CHANGE_PROPERTY_TAGS:
      return { ...state, propertyTags: action.payload };
    case CHANGE_SERVICE_PROVIDER:
      return { ...state, serviceProvider: action.payload };
    case CHANGE_PROPERTY:
      return { ...state, propertyId: action.payload };

    case CHANGE_DOMAINS:
      return { ...state, domains: action.payload };

    case CHANGE_TIMEZONE:
      return { ...state, timeZone: action.payload };

    case CHANGE_CURRENCY:
      return { ...state, currency: action.payload };

    case CHANGE_GROUP_BILLING_CURRENCY:
      return { ...state, groupBillingCurrency: action.payload };

    case CHANGE_USER:
      return { ...state, email: action.payload };

    case CHANGE_USER_NAME:
      return { ...state, userName: action.payload };

    case CHECK_VOUCHER_ENGINE:
      return { ...state, isVoucherEngine: action.payload };
    case CHANGE_GROUP:
      return { ...state, groupId: action.payload };
    case CHECK_SALESFORCE:
      return { ...state, salesforceId: action.payload };

    case CHANGE_CLODBEDS:
      return { ...state, cloudBedsId: action.payload };

    case CHANGE_GROUP_LOGO:
      return { ...state, serviceProviderLogo: action.payload };

    case CHANGE_TABS:
      return { ...state, integrationTab: action.payload };

    case CHANGE_INSTAGRAM:
      return { ...state, instagramId: action.payload };
      
    case CHANGE_CURRENT_INTEGRATION_TAB:
      return { ...state, currentIntegrationTab: action.payload };
    default:
      return { ...state };
  }
};
